import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgOurSlots = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 84 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#4DFF82"
        d="M0 10.667C0 4.776 4.776 0 10.667 0h42.666C59.224 0 64 4.776 64 10.667v42.666C64 59.224 59.224 64 53.333 64H10.667C4.776 64 0 59.224 0 53.333z"
      />
      <path
        fill="#4DFF82"
        fillRule="evenodd"
        d="M74.238 6a8 8 0 0 1 3 15.415v18.92c0 1.472-1.248 2.665-2.786 2.665H64.238c-1.538 0-1.208-1.193-1.208-2.664s-.33-2.664 1.208-2.664h7.429V21.575A8 8 0 0 1 74.238 6m0 5.333a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334"
        clipRule="evenodd"
      />
      <path
        fill="#010D50"
        d="M51.154 32.022c-5.97 1.882-12.114 3.036-18.308 3.036s-12.362-1.153-18.308-3.036c-.397-.125-.72.301-.422.627 3.592 3.638 8.473 5.895 13.478 6.849 1.734.326 3.492.502 5.252.502s3.518-.176 5.252-.502c5.005-.98 9.86-3.21 13.478-6.849.273-.326-.025-.752-.422-.627"
      />
    </svg>
  );
};
export default SvgOurSlots;
